import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getPriceDetails } from '@/utils/api';
import { ErrorBoundary } from 'react-error-boundary';
import { useAuthContext } from '@/contexts/authContext';
import PaymentForm from './form';
import CartMenu from '@/components/pages/subscription/cart';
import SimpleLoader from '@/components/loaders/simpleLoader';
import Header from '@/components/commons/header';
import ErrorFallback from '@/components/commons/error';
import { StripePrice } from '@/utils/types';
import i18n from '@/utils/i18n';
import { stripePriceIds, stripeEnv } from '@/utils/config';
export default function SubscriptionPage() {
  const { region, loading } = useAuthContext();
  const [prices, setPrices] = useState<StripePrice[]>([]);
  const [searchParams] = useSearchParams();
  const planIds = (searchParams.getAll('planid') || []) as string[];
  const priceIds = (searchParams.getAll('priceid') || []) as string[];
  const locale = searchParams.get('locale');
  useEffect(() => {
    const fetchPricesDetails = async () => {
      if (!priceIds.length) return;

      const prices = await Promise.all(priceIds.map(priceId => getPriceDetails(priceId)));
      setPrices(prices);
    };

    if (planIds.length) {
      // For compatibility with old URLs (product vs price objects)
      for (const planId of planIds) {
        if (planId.includes('archireport_pro_yearly')) {
          priceIds.push(stripePriceIds[stripeEnv].yearly);
        } else if (planId.includes('archireport_pro_monthly')) {
          priceIds.push(stripePriceIds[stripeEnv].monthly);
        }
      }
    }

    if (priceIds.length) {
      fetchPricesDetails();
    }

    i18n.changeLanguage(locale ?? navigator.languages[0]);
  }, []);

  if (loading) {
    return <SimpleLoader />;
  }

  return (
    <>
      <Header />
      <div className="h-16" />
      <div className="flex flex-col lg:flex-row gap-8 p-8 max-w-6xl mx-auto">
        {region && prices?.length > 0 && (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <PaymentForm prices={prices} />
            {prices.length > 0 && <CartMenu />}
          </ErrorBoundary>
        )}
      </div>
    </>
  );
}
